import { useMutation } from '@tanstack/react-query';
import { documentService, UpdateDocumentPayload } from '@services/document';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { DOCUMENTS_QUERY_KEY } from './useDocuments';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useEditDocument = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['documents', 'update'],
    mutationFn: async (payload: UpdateDocumentPayload) => {
      return await documentService.updateDocument(payload);
    },
    onSuccess: () => {
      toast.success(tActionMessages.documentUpdatedSuccessfully);

      // Force refetch relevant queries to immediately refresh the UI
      queryClient.refetchQueries({ queryKey: [DOCUMENTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: ['project'] });
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
    onError: (error: any) => {
      console.error('Document update error:', error);
      toast.error(
        getErrorMessage(error, 'Failed to update document. Please try again.'),
      );
    },
  });
};

export default useEditDocument;
